import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
import { PaymentCycle } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import GiftIconOrange from '../../../assets/images/subscription-page/gift-icon-orange.svg';
import GiftIconPurple from '../../../assets/images/subscription-page/gift-icon-purple.svg';
import s from '../Cycles/Cycles.scss';

interface YearlyBenefitsProps {
  rootStore: RootStore;
  cycleId: PaymentCycle;
}

const YEARLY_BENEFITS = [
  {
    translationKey:
      'premium-purchase-plan.cycle_selection.yearly_benefits.yearly_benefits_saving',
    showGiftIcon: false,
  },
  {
    translationKey:
      'premium-purchase-plan.cycle_selection.yearly_benefits.free_domain',
    showGiftIcon: true,
  },
] as const;

const YearlyBenefitsComp: React.FC<YearlyBenefitsProps> = ({
  rootStore,
  cycleId,
}) => {
  const { t } = useTranslation();
  const { isInSale } = rootStore.appStore;

  const GiftIcon = isInSale ? GiftIconOrange : GiftIconPurple;

  return (
    <Box
      className={classNames(s.yearlyBenefits, {
        [s.yearlyBenefitsSale]: isInSale,
      })}
      dataHook='yearly-benefits'
      direction='vertical'
      gap='10px'
      padding='18px'
      borderRadius='6px'
      width='100%'
    >
      <Text weight='bold' size='small' dataHook='yearly-benefits-heading'>
        {t(
          'premium-purchase-plan.cycle_selection.yearly_benefits.title_multi_year_cycle',
          { years: cycleId },
        )}
      </Text>
      <Text weight='normal' size='small' listStyle='circle'>
        <ul data-hook='yearly-benefits-list'>
          {YEARLY_BENEFITS.map(({ translationKey, showGiftIcon }) => (
            <li key={translationKey} data-hook='yearly-benefit-item'>
              <Box direction='horizontal' verticalAlign='middle' gap='6px'>
                {t(translationKey, { years: cycleId })}
                {showGiftIcon && (
                  <Box width='18px' height='18px'>
                    <GiftIcon />
                  </Box>
                )}
              </Box>
            </li>
          ))}
        </ul>
      </Text>
    </Box>
  );
};

export const YearlyBenefits = withInjectedRootStore(YearlyBenefitsComp);
